import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Terms from './Terms';
import Privacy from './Privacy';
import Support from './Support';
import LandingPage from './LandingPage';
import Apply from './Apply';
import Android from './Android';

// Loaded on demand, so visitors to the public pages never download it.
const Admin = lazy(() => import('./Admin'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/android" element={<Android />} />
        <Route path="/terms" element={<LegalPage><Terms /></LegalPage>} />
        <Route path="/privacy" element={<LegalPage><Privacy /></LegalPage>} />
        <Route path="/support" element={<LegalPage><Support /></LegalPage>} />
        <Route
          path="/admin"
          element={
            <Suspense fallback={null}>
              <Admin />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

function LegalPage({ children }) {
  return (
    <div className="App">
      <main className="App-main">{children}</main>
    </div>
  );
}

export default App;
